import React from 'react';
import * as ReactRouterDOM from 'react-router-dom';
import { useAppContext } from '../../context/AppContext.js';
import BudgetCapitalTop from './BudgetCapitalTop.js';
import ApiService from '../../services/ApiService.js';

const BudgetCapital = ReactRouterDOM.withRouter(function ({ match }) {
  const { setError } = useAppContext();
  const [budgetCapital, setBudgetCapital] = React.useState(null);

  React.useEffect(() => {
    fetchBudgetCapital();
  }, []);

  const fetchBudgetCapital = async function () {
    try {
      setBudgetCapital(await ApiService.getBudgetCapital(match.params.budgetCapitalId));
    }
    catch (error) {
      setError(error);
      return;
    }
  }
  
  if (budgetCapital === null || budgetCapital === undefined) {
    return (
      <div />
    );
  }
  
  return (
    <div>
      {budgetCapital ? (
        <div className="p-1">
          <div className="border bg-light">
            <div className="p-2 fs-6">
              <BudgetCapitalTop budgetCapital={budgetCapital} />
            </div>
          </div>
        </div>
      ) : null}
      <div className="d-flex flex-wrap">
        <div className="col-lg-6 col-md-12 col-sm-12 col-12">
        </div>
        <div className="col-lg-6 col-md-12 col-sm-12 col-12">
        </div>
      </div>
    </div>
  );
})

export default BudgetCapital;
